// ----------------------------------------------------------------------

// Android phones report "Android" + "Mobile" in their UA; Android tablets omit "Mobile".
// iOS and desktop browsers never match.
export const isAndroidPhone = () => {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent || '';
  return /Android/i.test(ua) && /Mobile/i.test(ua);
};
